import { Injectable } from '@angular/core';
import { concatLatestFrom } from '@ngrx/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { PatchObject } from './models';
import { StandardteksterSelectors, StdtextareaService } from './services';
import * as StandardteksterActions from './standardtekster.actions';
import {AuthSelectors} from '../auth/store/services';

@Injectable()
export class StandardteksterEffects {

    checkForLoadV2Standardtekster$ = createEffect(() => this.actions$.pipe(
        ofType(StandardteksterActions.checkForLoadStandardtekster),
        concatLatestFrom(() => [
            this.standardteksterSelector.loaded$,
            this.standardteksterSelector.loading$
        ]),
        map(([_, loaded, loading]) => {
            if (!loading && !loaded) {
                return StandardteksterActions.loadStandardtekster();
            }
            return StandardteksterActions.noLoadStandardtekster();
        })
    ));

    loadStandardtekster$ = createEffect(() => this.actions$.pipe(
        ofType(StandardteksterActions.loadStandardtekster),
        switchMap(() => this.standardteksterService.getStandardtekster().pipe(
            map(standardtekster => StandardteksterActions.loadStandardteksterSuccess({ standardtekster }),
            catchError(() => EMPTY))
        ))
    ));

    updateStandardtekst$ = createEffect(() => this.actions$.pipe(
        ofType(StandardteksterActions.updateStandardtekst),
        switchMap((payload) => {
            const newStandardtekst = payload.standardtekst;
            const patchValues: PatchObject[] = [
                {value: newStandardtekst.orden, path: '/orden', op: 'replace'},
                {value: newStandardtekst.situation, path: '/situation', op: 'replace'}
            ];
            return this.standardteksterService.updateStandardtekst(newStandardtekst.id, patchValues).pipe(
                map(standardtekst => StandardteksterActions.updateStandardtekstSuccess({standardtekst})),
                catchError(() => EMPTY)
            );
        })
    ));

    createStandardtekst$ = createEffect(() => this.actions$.pipe(
        ofType(StandardteksterActions.createStandardtekst),
        withLatestFrom(this.authSelector.user$),
        switchMap(([payload, user]) => {
            const newStandardtekst = {
                ...payload.standardtekst,
                kontor: user.indexCard.kontor,
                cb: user.username,
                cd: new Date()
            };
            return this.standardteksterService.createStandardtekst(newStandardtekst).pipe(
                map(standardtekst => StandardteksterActions.createStandardtekstSuccess({standardtekst})),
                catchError(() => EMPTY)
            );
        })
    ));

    deleteStandardtekst$ = createEffect(() => this.actions$.pipe(
        ofType(StandardteksterActions.deleteStandardtekst),
        switchMap((payload) => {
            const id = payload.id;
            return this.standardteksterService.deleteStandardtekst(id).pipe(
                map(() => StandardteksterActions.deleteStandardtekstSuccess({ id })),
                catchError(() => EMPTY)
            );
        })
    ));

    constructor(
        private actions$: Actions,
        private standardteksterService: StdtextareaService,
        private standardteksterSelector: StandardteksterSelectors,
        private authSelector: AuthSelectors
    ) {}

}
